import { createContext } from 'react';

interface VendorShareContextType {
  vendorSharable: boolean;
  vendorName: string;
  vendorSlug: string;
  isStore: boolean;
}

export const VendorShareContext = createContext<VendorShareContextType>({
  vendorName: '',
  vendorSharable: true,
  vendorSlug: '',
  isStore: false,
});
